import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "index-sections" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-circle-o-left",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = { class: "section-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "gradient-text" }, " Playlist", -1)
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "view-link" }, [
  /*#__PURE__*/_createTextVNode("View playlist on YouTube "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-arrow-circle-o-right",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "video-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_video_component = _resolveComponent("video-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/videos",
      class: "nav-link"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" Back to the list of video playlists ")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.videoData?.title) + " ", 1),
        _hoisted_5
      ]),
      _createElementVNode("h4", null, _toDisplayString(_ctx.videoData?.items.length) + " total videos.", 1),
      _createElementVNode("a", {
        href: 'https://youtube.com/playlist?list=' + _ctx.videoData?.id,
        target: "_blank",
        class: "section-link"
      }, _hoisted_8, 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoData?.items, (video) => {
        return (_openBlock(), _createBlock(_component_video_component, {
          key: video.id,
          title: video.title,
          youtubeid: video.id
        }, null, 8, ["title", "youtubeid"]))
      }), 128))
    ])
  ]))
}